/**
 * description : native app 에서 호출하는 에러를 발생 시키는 전역변수 모음
 * sentry 에러를 발생 시키는 함수로 전역변수로 등록하여 native app 에서 호출할 수 있도록 처리
 */
export default defineNuxtRouteMiddleware(() => {
  window.getAogLogToolBarClose = () => {}
  window.setRootViewResult = () => {}
  window.printAllCookies = () => {}
  window.setApplicationStatus = () => {}
})
